export default __webpack_public_path__ + "static/media/2191.7c47c8f1.png";